import { MouseEvent, useRef, useState } from 'react';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';

import MoreHorizontalIcon from '@/components/Icons/MoreHorizontalIcon';

import { ActionsMenuContext } from './context';
import { ActionsMenuProps } from './types';

function ActionsMenu({ variant, children, buttonSx = {} }: ActionsMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const anchorEl = useRef<HTMLButtonElement | null>(null);

  function handleClick() {
    setIsOpen(true);
  }

  function handleClose() {
    setIsOpen(false);
  }

  function stopPropagation(ev: MouseEvent) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  let button = (
    <Button
      variant="outlined"
      color="secondary"
      data-cy="actions-menu"
      size="small"
      ref={anchorEl}
      endIcon={<KeyboardArrowDownIcon />}
      onClick={handleClick}
      sx={buttonSx}
    >
      Actions
    </Button>
  );

  if (variant === 'minimal') {
    button = (
      <IconButton data-cy="actions-menu" ref={anchorEl} onClick={handleClick} sx={buttonSx}>
        <MoreHorizontalIcon />
      </IconButton>
    );
  }

  return (
    <Box onClick={stopPropagation}>
      {button}
      <ActionsMenuContext.Provider value={{ closeMenu: handleClose }}>
        <Menu
          anchorEl={anchorEl.current}
          open={isOpen}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          data-cy="actions-menu-popover"
        >
          {children}
        </Menu>
      </ActionsMenuContext.Provider>
    </Box>
  );
}

export default ActionsMenu;
